// src/pages/logistica/DiasInventario.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

// Umbrales de ejemplo — AJUSTAR con Logística/Planeación, no están confirmados.
const UMBRAL_BAJO = 10;  // menos de esto = riesgo de desabasto
const UMBRAL_ALTO = 45;  // más de esto = posible sobreinventario

function semaforoDe(dias) {
  if (dias === null || dias === undefined) return 'gris';
  if (dias < UMBRAL_BAJO) return 'rojo';
  if (dias > UMBRAL_ALTO) return 'amarillo';
  return 'verde';
}

const COLORES = { rojo: '#B23A48', amarillo: '#B8862E', verde: '#3E7C5A', gris: '#8A7690' };
const FONDOS = { rojo: '#FDF3F1', amarillo: '#FBF6E9', verde: '#F0F7F2', gris: '#F5F3F0' };
const ETIQUETAS = { rojo: 'Riesgo de desabasto', amarillo: 'Posible sobreinventario', verde: 'Saludable', gris: 'Sin consumo reciente' };

export default function DiasInventario() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [sincronizando, setSincronizando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/logistica/dias-inventario');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  async function handleSincronizar() {
    try {
      setSincronizando(true);
      setMensaje(null);
      const res = await api.post('/api/logistica/dias-inventario/sync');
      await cargar();
      setMensaje({ tipo: 'ok', texto: `✓ Sincronizado: ${res.data.procesados}/${res.data.total} salidas desde NetSuite.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo sincronizar con NetSuite.' });
    } finally {
      setSincronizando(false);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  const sinConsumo = filas.filter((f) => f.dias_inventario === null).length;

    return (
    <div style={styles.contenedor} className="contenedor-captura">
      <div style={styles.encabezado}>
        <div>
          <h1 style={styles.titulo}>Días de Inventario</h1>
          <p style={styles.subtitulo}>Piezas disponibles ÷ Consumo Promedio Diario (salidas Facturadas, últimos 30 días).</p>
        </div>
        <button onClick={handleSincronizar} disabled={sincronizando} style={styles.botonSync}>
          {sincronizando ? 'Sincronizando...' : '↻ Sincronizar Salidas de Ventas'}
        </button>
      </div>

      <div style={styles.leyenda}>
        {['rojo', 'verde', 'amarillo'].map((s) => (
          <span key={s} style={{ ...styles.chipLeyenda, background: FONDOS[s], color: COLORES[s] }}>
            <span style={{ ...styles.puntoLeyenda, background: COLORES[s] }} /> {ETIQUETAS[s]}
          </span>
        ))}
        <span style={styles.notaUmbral}>(umbrales de ejemplo: &lt;{UMBRAL_BAJO}d rojo, &gt;{UMBRAL_ALTO}d amarillo — pendiente de confirmar con Logística/Planeación)</span>
      </div>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      {sinConsumo > 0 && (
        <div style={styles.avisoSinConsumo}>
          ⚠ {sinConsumo} artículo{sinConsumo === 1 ? '' : 's'} sin ninguna salida Facturada en los últimos 30 días — no se puede calcular Días de Inventario para esos (aparecen sin dato, no en 0).
        </div>
      )}

      <div style={styles.tarjeta}>
        <div className="tabla-scroll">
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Artículo</th>
                <th style={styles.thNum}>Piezas disponibles</th>
                <th style={styles.thNum}>Consumo diario prom.</th>
                <th style={styles.thNum}>Días de Inventario</th>
                <th style={styles.th}>Estado</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((f) => {
                const semaforo = semaforoDe(f.dias_inventario);
                return (
                  <tr key={f.articulo} style={{ background: FONDOS[semaforo] }}>
                    <td style={styles.td}>{f.articulo}</td>
                    <td style={styles.tdNum}>{Number(f.piezas_disponibles).toLocaleString('es-MX')}</td>
                    <td style={styles.tdNum}>{f.consumo_diario_promedio ? Number(f.consumo_diario_promedio).toLocaleString('es-MX') : '—'}</td>
                    <td style={{ ...styles.tdNum, fontWeight: 700, color: COLORES[semaforo] }}>
                      {f.dias_inventario !== null ? f.dias_inventario : '—'}
                    </td>
                    <td style={{ ...styles.td, color: COLORES[semaforo], fontSize: '11px', fontWeight: 600 }}>{ETIQUETAS[semaforo]}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>    
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '900px' },
  encabezado: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '14px', marginBottom: '4px', flexWrap: 'wrap' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtitulo: { fontSize: '12px', color: '#8A7690' },
  botonSync: { flexShrink: 0, padding: '9px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap' },
  leyenda: { display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center', margin: '14px 0' },
  chipLeyenda: { display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '11px', fontWeight: 600, padding: '5px 10px', borderRadius: '20px' },
  puntoLeyenda: { width: '8px', height: '8px', borderRadius: '50%', display: 'inline-block' },
  notaUmbral: { fontSize: '10.5px', color: '#8A7690' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  avisoSinConsumo: { fontSize: '11.5px', color: '#8A7300', background: '#FBF6E9', border: '1px solid #E8D48A', borderRadius: '8px', padding: '10px 14px', marginBottom: '14px' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' },
  th: { textAlign: 'left', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  thNum: { textAlign: 'right', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  td: { padding: '7px 10px', borderBottom: '1px solid #F0E9E0' },
  tdNum: { padding: '7px 10px', textAlign: 'right', borderBottom: '1px solid #F0E9E0' },
};